import * as React from 'react';
import Base from './Base';
const Paragraph = (props, ref) => (React.createElement(Base, Object.assign({ ref: ref }, props, { component: "div" })));
export default React.forwardRef(Paragraph);
